import { createContext, ReactNode, useContext } from "react";
import { useStore } from "@xyflow/react";

export type SequenceCanvasLod = "full" | "compact" | "overview";

export const MIN_SEQUENCE_CANVAS_ZOOM = 0.25;
export const COMPACT_SEQUENCE_CANVAS_ZOOM = 0.32;
export const OVERVIEW_SEQUENCE_CANVAS_ZOOM = 0.27;

export function getSequenceCanvasLod(zoom: number): SequenceCanvasLod {
  if (zoom < OVERVIEW_SEQUENCE_CANVAS_ZOOM) {
    return "overview";
  }

  if (zoom < COMPACT_SEQUENCE_CANVAS_ZOOM) {
    return "compact";
  }

  return "full";
}

const SequenceCanvasLodContext = createContext<SequenceCanvasLod>("full");

export function SequenceCanvasLodProvider({
  children,
}: {
  children: ReactNode;
}) {
  const lod = useStore((state) => getSequenceCanvasLod(state.transform[2]));

  return (
    <SequenceCanvasLodContext.Provider value={lod}>
      {children}
    </SequenceCanvasLodContext.Provider>
  );
}

export function useSequenceCanvasLod() {
  return useContext(SequenceCanvasLodContext);
}
